"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BURGER_MENU = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _wdh = require("@demant/wdh");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Adds a burger menu. It needs to be hooked up on the root <ul> element
 * with the following structure:
 *
 * <ul class="my-class"> // Root element
 *     <li> (level1)
 *         <a>Group 1</a>
 *         <ul>
 *              <li> (level2)
 *                  <a>SubGroup1</a>
 *                  <ul>
 *                      <li>Burger menu item 1</li>
 *                      <li>Burger menu item 2</li>
 *                      ... (more items)
 *                  </ul>
 *              </li>
 *              ... (more subgroups)
 *         </ul>
 *     </li>
 *     ... (more groups)
 * </ul>
 *
 * The plugin will add the class 'dgs-burger-menu' to the Root element, used to provide some basic styling.
 *
 * Full list of parameters can be found on the bottom of this file
 *
 * An example of how to invoke the burger-menu:
 *  $(".my-class").burgerMenu({
 *      appendElements: [$(".super-element"), $(".required-element > .small-feature")]
 *      secondLevelNav: false
 *  });
 *
 */
// Events trigger by the burger menu
var BURGER_MENU = {
  ANIMATION_START: 'burgerMenuAnimationStart',
  ANIMATION_COMPLETE: 'burgerMenuAnimationComplete',
  OPEN: 'burgerMenuOpen',
  CLOSE: 'burgerMenuClose'
};
exports.BURGER_MENU = BURGER_MENU;

(function ($) {
  $.fn.burgerMenu = function (customOptions) {
    var $this = $(this); // This private settings are here because we do not have support for them (yet)

    var privateSettings = {
      magnitude: 100,
      // Integer: Percentage value of how much the burgermenu will slide
      backButtonShowClass: 'show-btn',
      // String: Class that will be added to the back button when needs to be shown
      submenuTitleClass: 'sub-burger-title',
      // String: Class added to the created navigation items on a sub-menu
      lastNavigationClass: 'last-navigation' // String: class to add on the last child of the navigation. Only used when groupTwoLastLevels is true

    };
    var settings = $.extend({}, $.fn.burgerMenu.defaults, customOptions, privateSettings);
    var burgermenuClass = 'dgs-burger-menu'; // Class which will be added to $this element

    var $backButton = $(".".concat(settings.backButtonClass)); // Back button

    var animationRunning = false; // Boolean to check if an animation is currently running

    var registeredAnimation; // Holds which animation to use based on configuration

    var f = {
      init: function init() {
        f.actions.addClasses(); // Initialize events

        f.events.navExpanderClick();

        if (settings.createBackButton === true) {
          f.actions.createBackButton();
        }

        f.events.backButtonClick(); // Move the burger menu outside the viewport

        f.actions.arrangeElements();
        f.actions.setZIndex();
        f.events.setupMenuItemsClick(); // Appends elements to the burger menu UL

        f.actions.appendExtraElements();

        if (settings.secondLevelNav === false) {
          f.actions.disableSecondLevelNav();
        }

        if (settings.createSubmenuNavigation === true) {
          f.actions.createSubmenuNavigation();
        } // Register the animation to use


        if (typeof settings.animation === 'function') {
          registeredAnimation = settings.animation;
        } else {
          registeredAnimation = f.animations[settings.animation];
        }
      },
      actions: {
        /**
                 * Adds the required classes to support the burger menu functionality
                 */
        addClasses: function addClasses() {
          $this.addClass(burgermenuClass).addClass(settings.menuItemsClass);
          $this.find('li').each(function () {
            if ($(this).find('ul > li').length === 0) {
              // HINT: Configure the nested level
              $(this).addClass(settings.emptyMenuClass);
            }
          });

          if (settings.navTracking === true) {
            $this.find('li > a').each(function () {
              var href = $(this).attr('href');

              if (window.location.pathname.indexOf(href) === 0 || window.location.pathname === href) {
                $(this).addClass('current');
              }
            });
          } else if (typeof settings.navTracking === 'function') {
            settings.navTracking($this); // Support custom navigation
          }
        },

        /**
                 * Opens a menu item
                 *
                 * @param {jQuery} $menuItem <> Menu item jQuery object, hooks up to an UL element
                 */
        openMenuItem: function openMenuItem($menuItem) {
          registeredAnimation($menuItem, settings.magnitude, settings.menuPlacement);
          $menuItem.addClass(settings.expandedMenuItem); // Only add this when the animation ended
          // Only show the back button if there is more than one level?

          if ($(".".concat(settings.expandedMenuItem), $this).length >= 1) {
            $backButton.addClass(settings.backButtonShowClass);
          }
        },

        /**
                 * Closes a menu item
                 *
                 * @param {jQuery} $menuItem <> Menu item jQuery object, hooks up to an UL element
                 */
        closeMenuItem: function closeMenuItem($menuItem) {
          registeredAnimation($menuItem, settings.magnitude * -1, settings.menuPlacement, function () {
            $menuItem.removeClass(settings.expandedMenuItem);
          });

          if ($menuItem.parent().parent()[0] === $this[0]) {
            $backButton.removeClass(settings.backButtonShowClass);
          }
        },

        /**
                 * Arranges the UL elements so they are outside the viewport
                 */
        arrangeElements: function arrangeElements() {
          // Move the navigation menu outside the viewport
          $this.css(settings.menuPlacement, '-100%');

          if (settings.groupTwoLastLevels === false) {
            $this.find('li > ul').each(function () {
              $(this).css(settings.menuPlacement, "".concat(settings.magnitude * -1, "%"));
            });
          } else {
            f.actions.indentElements($this.find('> li > ul'));
          }
        },

        /**
                 * Iterates through a list element and it's children's lists recursively and sets the z-index based on the level.
                 * Used for the submenus so that they won't overlap.
                 *
                 * @param list List element - either root or a child list.
                 * @param zIndex The z-index that the list will get. Upon initial call it will be the starting value with 1 as default.
                 */
        setZIndex: function setZIndex() {
          var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $this;
          var zIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (zIndex == null) zIndex = settings.zIndex;
          list.css('z-index', zIndex);
          list.children('li').children('ul').each(function () {
            f.actions.setZIndex($(this), ++zIndex);
          });
        },

        /**
                 * Arranges elements outside the viewport but if a element does not have sub-navigation it adds the lastChildClass class
                 *
                 * @param ul Element to indent from and beyond
                 */
        indentElements: function indentElements(ul) {
          ul.css(settings.menuPlacement, "".concat(settings.magnitude * -1, "%"));
          ul.children('li').each(function () {
            if ($(this).children('ul').length > 0 && $(this).find('> ul > li > ul').length > 0) {
              f.actions.indentElements($(this).children('ul'));
            } else if ($(this).children('ul').length > 0) {
              $(this).addClass(settings.lastNavigationClass);
            }
          });
        },

        /**
                 * Adds extra elements to the burger menu
                 * IMPORTANT: Be advise that this will MOVE the elements, and most likely will need custom styling
                 */
        appendExtraElements: function appendExtraElements() {
          // Appends elements to the burger menu UL
          if (settings.appendElements) {
            $.each(settings.appendElements, function () {
              $(this).appendTo($this);
            });
          }
        },

        /**
                 * Creates a default back button before the burgerMenu.
                 */
        createBackButton: function createBackButton() {
          var backButton = "<a href=\"#\" class=\"".concat(settings.backButtonClass, "\">Back</a>");
          $this.before(backButton);
          $backButton = $(".".concat(settings.backButtonClass));
        },

        /**
                 * Disables the second level element from being clickable, so it is more like a title than a page.
                 * @deprecated This was intended to be used when only 2 levels where supported
                 */
        disableSecondLevelNav: function disableSecondLevelNav() {
          $this.find('> li > ul > li > a').each(function () {
            $(this).addClass(settings.disabledClass).click(function (event) {
              event.preventDefault();
            });
          });
        },

        /**
                 * Closes all open menu items.
                 */
        closeAllMenuItems: function closeAllMenuItems() {
          // Loop the open elements and close them
          $(".".concat(settings.expandedMenuItem), $this).addBack().each(function () {
            f.actions.closeMenuItem($(this));
          }); // Remove the expander class form the nav-menu

          if ($(settings.expanderSelector).hasClass(settings.navExpandedClass)) {
            $(settings.expanderSelector).removeClass(settings.navExpandedClass);
          }
        },

        /**
                 * On the burger menu the first navigation item is used to open the second level navigation.
                 * This function creates a copy of the previous level link and adds it to the current level, so the user
                 * can use it to go to a previous level navigation page.
                 */
        createSubmenuNavigation: function createSubmenuNavigation() {
          $this.find('li').each(function () {
            if (!$(this).hasClass(settings.lastNavigationClass)) {
              var $aTag = $(this).children('a').clone().removeClass('current');
              $(this).children('ul').prepend($('<li>').addClass(settings.submenuTitleClass).addClass(settings.emptyMenuClass).append($aTag));
            }
          });
        }
      },
      events: {
        /**
                 * Event for when the navigation expander element is clicked.
                 * It opens the burger menu, and closes all the open elements
                 */
        navExpanderClick: function navExpanderClick() {
          $(settings.expanderSelector).click(function (e) {
            e.preventDefault();
            if (animationRunning) return false; // Do not execute if an animation is running

            if ($this.hasClass(settings.expandedMenuItem)) {
              // This is not reaaaally a menu item, but is an UL...
              // Closing the burger menu
              f.actions.closeAllMenuItems();
              $(this).removeClass(settings.navExpandedClass);
              $backButton.removeClass(settings.backButtonShowClass);
              f.callbacks.burgerMenuClose();
            } else {
              // Opening the burger menu
              $this.find('li > a.current').each(function () {
                if ($(this).next().length > 0 && $(this).next().is('ul')) {
                  f.actions.openMenuItem($(this).next('ul'));
                }
              });
              f.actions.openMenuItem($this);
              $(this).addClass(settings.navExpandedClass);
              f.callbacks.burgerMenuOpen();
            }
          });
        },

        /**
                 * Handles the click of each menu item <a> link, which opens and closes deeper navigation items
                 */
        setupMenuItemsClick: function setupMenuItemsClick() {
          // Menu list IS NOT an UL but an LI
          $this.find("li:not(.".concat(settings.emptyMenuClass, "):not(.").concat(settings.lastNavigationClass, ") > a")).click(function (event) {
            event.preventDefault();

            if (!animationRunning) {
              var $menuItem = $(this).next('ul'); // The next UL is the one that has the menu

              if ($menuItem.hasClass(settings.expandedMenuItem)) {
                f.actions.closeMenuItem($menuItem);
              } else {
                f.actions.openMenuItem($menuItem);
              }
            }
          });

          if (settings.closeMenuAfterClick === true) {
            $this.find("li.".concat(settings.emptyMenuClass, " > a")).click(function () {
              if (!animationRunning) {
                f.actions.closeAllMenuItems();
                f.callbacks.burgerMenuClose();
              }
            });
          }
        },

        /**
                 * Handles the back button click event, closing the deepest open element.
                 *
                 * NOTE: This does not require that the burger menu is open
                 */
        backButtonClick: function backButtonClick() {
          $(document).on('click', ".".concat(settings.backButtonClass), function (event) {
            event.preventDefault();

            if (!animationRunning) {
              // Do not close anything if an animation is running
              // Get the last one that is expanded
              var $lastOpenElement = $(".".concat(settings.expandedMenuItem), $this).last();
              f.actions.closeMenuItem($lastOpenElement);
            }
          });
        }
      },

      /**
             * Available animation for the burger menu
             */
      animations: {
        slideAll: function slideAll(amount, direction) {
          // NOTE: This was not working due to overflow
          var params = {};
          var currentPos = $this[0].style[direction]; // This are the animation options

          var options = {
            duration: 500,
            start: function start() {
              animationRunning = true;
            },
            complete: function complete() {
              animationRunning = false;
            }
          };
          params[direction] = "".concat(Number(currentPos.replace(/%|px|rem|em/, '')) + amount, "%");
          $this.animate(params, options);
        },

        /**
                 * Slides each navigation element on top of each other, one by one.
                 *
                 * @param {jQuery}   $menuItem   <> Menu item to apply the animation
                 * @param {int}      amount      <> Magnitude of the movement applied
                 * @param {string}   direction   <> Which direction the animation will be done
                 * @param {function} callbackEnd <null> Optional callback that will be called when the animation ends
                 */
        slideSingle: function slideSingle($menuItem, amount, direction, callbackEnd) {
          var params = {};
          var currentPos = $menuItem[0].style[direction]; // This are the animation options

          var options = {
            duration: settings.animationSpeed,
            start: function start() {
              f.callbacks.startAnimation();
            },
            complete: function complete() {
              f.callbacks.completeAnimation();

              if (typeof callbackEnd === 'function') {
                callbackEnd();
              }
            }
          };
          params[direction] = "".concat(Number(currentPos.replace(/%|px|rem|em/, '')) + amount, "%");
          $menuItem.animate(params, options);
        }
      },

      /**
             * Trigger some known
             */
      callbacks: {
        startAnimation: function startAnimation() {
          (0, _wdh.triggerEvent)(BURGER_MENU.ANIMATION_START);
          animationRunning = true;
        },
        completeAnimation: function completeAnimation() {
          (0, _wdh.triggerEvent)(BURGER_MENU.ANIMATION_COMPLETE);
          animationRunning = false;
        },
        burgerMenuOpen: function burgerMenuOpen() {
          (0, _wdh.triggerEvent)(BURGER_MENU.OPEN);
        },
        burgerMenuClose: function burgerMenuClose() {
          (0, _wdh.triggerEvent)(BURGER_MENU.CLOSE);
        }
      }
    };
    return this.each(function () {
      f.init();
    });
  }; // Public defaults


  $.fn.burgerMenu.defaults = {
    navTracking: true,
    // Bool|Function: This can be a function that will receive $this
    expanderSelector: '.nav-expander',
    // String: Selector of the element that will trigger the burger menu open
    navExpandedClass: 'nav-expanded',
    // String: Class to add to the nav-expander when the menu is open
    emptyMenuClass: 'no-dropdown',
    // String: Class that will be added to elements without sub navigation
    expandedMenuItem: 'expanded',
    // String: Be aware that this may be added also on the expander element
    createBackButton: false,
    // Bool: Set to true to create a "default" but simple back button
    backButtonClass: 'nav-back',
    // String: Class of the back button
    menuItemsClass: 'text-center',
    // String: Class that will be added to the menu items. Out of the box this can be [text-center|text-left|text-right]
    appendElements: false,
    // Array|Boolean: Array of jQuery objects, or false to not append anything.
    secondLevelNav: true,
    // Bool: Enables or disables the second level navigation click event
    disabledClass: 'as-text',
    // String: Class that the disabled elements will have (directly related with "secondLevelNav")
    animation: 'slideSingle',
    // String|Function: String of the defined animation, or a function with an animation
    menuPlacement: 'left',
    // String: String to determine the direction/placement of the buttons
    animationSpeed: 300,
    // Int: Speed of the animation
    createSubmenuNavigation: true,
    // Bool: Set true to copy a first level nav link to the second level menu of that link
    groupTwoLastLevels: true,
    // Bool: Set true to group the last 2 navigation levels, so they appear as
    closeMenuAfterClick: false,
    // Bool: Set true to close the burgerMenu after clicking an element
    zIndex: 1 // Int: sets z-index for list and then increments +1 for each li

  }; // IMPORTANT: In order for the menuPlacement: Right to work, it needs a outer RELATIVE container
})(_jquery["default"]);